module.exports = __webpack_public_path__ + "img/ico-store-default.f6fdd555.svg";